<template>
  <b-card no-body class="rounded-xl h-full">
    <div class="row">
      <div class="col-sm-12">
        <b-card no-body class="card-h-bgf4f5f6">
          <b-tabs card class="tab-pd-b" active-nav-item-class="font-semibold">
            <b-tab title="Send Email" active>
              <b-card-text> <SendEmail /></b-card-text>
            </b-tab>

            <b-tab title="Template">
              <b-card-text><Templatetheme /></b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
  </b-card>
</template>

<script>
import SendEmail from "./components/SendEmail.vue";
import Templatetheme from "./campaignTemplate/TemplateTheme.vue";
import "../../../scss/Index.scss";
export default {
  components: {
    SendEmail,
    Templatetheme,
  },
  data() {
    return {};
  },
};
</script>
<style>
.tab-pd-b .nav-link {
  padding: 10px 15px !important;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  background-color: #fff !important;
}
.card-h-bgf4f5f6 > div > .card-header {
  background: #f4f5f6 !important;
}
</style>
